var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95 95",
    style: {
      enableBackground: "new 0 0 95 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#979797;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 95,
    height: 95
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,28.4C73.5,12.3,57.9,1.8,41.8,5C30,7.4,20.8,16.6,18.4,28.4C7,29.7-1.2,40,0.1,51.4 c1.2,10.5,10.1,18.4,20.7,18.4h14.9c1.6,0,3-1.3,3-3c0-1.6-1.3-3-3-3H20.8C12.6,63.8,6,57.1,6,48.9c0-8.2,6.7-14.8,14.9-14.8 c1.5,0,2.8-1.1,3-2.6c1.5-13,13.3-22.4,26.4-20.9c11,1.3,19.6,9.9,20.9,20.9c0.2,1.5,1.6,2.7,3.1,2.6c8.2,0,14.9,6.7,14.9,14.9 c0,8.2-6.7,14.9-14.9,14.9H59.5c-1.6,0-3,1.3-3,3c0,1.6,1.3,3,3,3h14.9c11.5-0.1,20.7-9.4,20.7-20.9 C94.9,38.4,87.1,29.6,76.7,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,57.8c1.1,1.2,3,1.2,4.2,0.1c1.2-1.1,1.2-3,0.1-4.2c0,0,0,0-0.1-0.1L49.7,41c-1.2-1.2-3-1.2-4.2,0 c0,0,0,0,0,0L32.9,53.6c-1.2,1.1-1.2,3-0.1,4.2c1.1,1.2,3,1.2,4.2,0.1c0,0,0,0,0.1-0.1l7.5-7.5v37.4c0,1.6,1.3,3,3,3 c1.6,0,3-1.3,3-3V50.3L58.1,57.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b2e88460b7186d066162cdccebfff732.svg";
export { ForwardRef as ReactComponent };